import React, { useState } from 'react';
import axios from 'axios';
import { userUrl } from '../constants/module-constants';
import usernameUtils from '../utils/usernameUtils';

const DeleteUser = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    const normalizedUsername = usernameUtils.normalize(username);

    if (!normalizedUsername || !password) {
      setError('Por favor completa todos los campos');
      setLoading(false);
      return;
    }

    if (!usernameUtils.isValid(normalizedUsername)) {
      setError(usernameUtils.validationMessage);
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        userUrl.DELETE_USER,
        { username: normalizedUsername, password }
      );

      setMessage(response.data.message);
      setUsername('');
      setPassword('');
    } catch (err) {
      setError(err.response?.data?.message || 'Error al eliminar usuario');
    } finally {
      setLoading(false);
    }
  };

  return React.createElement(
    'div',
    { style: styles.container },
    React.createElement(
      'div',
      { style: styles.card },
      React.createElement('h1', { style: styles.title }, 'Eliminar Usuario'),
      React.createElement(
        'p',
        { style: styles.warning },
        '⚠️ Esta acción es permanente y no se puede deshacer'
      ),
      React.createElement(
        'form',
        { onSubmit: handleDelete, style: styles.form },
        React.createElement(
          'div',
          { style: styles.inputGroup },
          React.createElement('label', { style: styles.label }, 'Usuario:'),
          React.createElement('input', {
            type: 'text',
            value: username,
            onChange: (e) => setUsername(usernameUtils.sanitizeInput(e.target.value)),
            style: styles.input,
            placeholder: 'Ingresa tu usuario',
            minLength: 3,
            maxLength: 30,
            pattern: usernameUtils.regex.source,
            autoCapitalize: 'none',
            disabled: loading,
          })
        ),
        React.createElement(
          'div',
          { style: styles.inputGroup },
          React.createElement('label', { style: styles.label }, 'Contraseña:'),
          React.createElement('input', {
            type: 'password',
            value: password,
            onChange: (e) => setPassword(e.target.value),
            style: styles.input,
            placeholder: 'Ingresa tu contraseña',
            disabled: loading,
          })
        ),
        message &&
          React.createElement(
            'div',
            { style: styles.successMessage },
            message
          ),
        error &&
          React.createElement('div', { style: styles.errorMessage }, error),
        React.createElement(
          'button',
          { type: 'submit', style: styles.button, disabled: loading },
          loading ? 'Eliminando...' : 'Eliminar Usuario'
        )
      )
    )
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
    padding: '20px',
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    maxWidth: '400px',
    width: '100%',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '10px',
    textAlign: 'center',
    color: '#333',
  },
  warning: {
    color: '#ff6b6b',
    textAlign: 'center',
    marginBottom: '30px',
    fontSize: '14px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#555',
  },
  input: {
    padding: '12px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    outline: 'none',
    transition: 'border-color 0.3s',
  },
  button: {
    padding: '12px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#dc3545',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  successMessage: {
    padding: '12px',
    backgroundColor: '#d4edda',
    color: '#155724',
    borderRadius: '4px',
    textAlign: 'center',
  },
  errorMessage: {
    padding: '12px',
    backgroundColor: '#f8d7da',
    color: '#721c24',
    borderRadius: '4px',
    textAlign: 'center',
  },
};

export default DeleteUser;
